export const systemIconValues = ['action-required', 'actionRequired', 'add', 'add-column-left', 'add-column-right', 'add-logic', 'add-row-above', 'add-row-below', 'addColumnLeft', 'addColumnRight', 'addLogic', 'addRowAbove', 'addRowBelow', 'alert', 'alert-triangle', 'alertTriangle', 'align-bottom', 'align-center', 'align-end', 'align-left', 'align-mid', 'align-right', 'align-start', 'align-top', 'alignBottom', 'alignCenter', 'alignEnd', 'alignLeft', 'alignMid', 'alignRight', 'alignStart', 'alignTop', 'approve', 'arrow-down', 'arrow-left', 'arrow-right', 'arrow-up', 'arrow-up-left', 'arrow-up-right', 'arrowDown', 'arrowLeft', 'arrowRight', 'arrowUp', 'arrowUpLeft', 'arrowUpRight', 'arrows-in', 'arrows-out', 'arrowsIn', 'arrowsOut', 'at', 'attachment', 'audio-wave', 'audioWave', 'authentication', 'auto-fill', 'autoFill', 'award', 'bag', 'bell', 'bell-slash', 'bellSlash', 'block', 'bold', 'bolt', 'book', 'book-open', 'book-person', 'bookOpen', 'bookPerson', 'bookmark', 'boolean', 'box-plus-above', 'box-plus-after', 'box-plus-before', 'box-plus-below', 'boxPlusAbove', 'boxPlusAfter', 'boxPlusBefore', 'boxPlusBelow', 'briefcase', 'brightness', 'browser', 'browser-stack', 'browserStack', 'building-civic', 'building-company', 'building-generic', 'building-person', 'buildingCivic', 'buildingCompany', 'buildingGeneric', 'buildingPerson', 'bulk-send', 'bulkSend', 'bulleted-list', 'bulletedList', 'calendar', 'camera', 'carbon-copy', 'carbonCopy', 'caret-down', 'caret-large-down', 'caret-large-left', 'caret-large-right', 'caret-large-up', 'caret-left', 'caret-right', 'caret-up', 'caret-xlarge-down', 'caret-xlarge-left', 'caret-xlarge-right', 'caret-xlarge-up', 'caretDown', 'caretLargeDown', 'caretLargeLeft', 'caretLargeRight', 'caretLargeUp', 'caretLeft', 'caretRight', 'caretUp', 'caretXlargeDown', 'caretXlargeLeft', 'caretXlargeRight', 'caretXlargeUp', 'certificate', 'chart-bar', 'chart-pie', 'chartBar', 'chartPie', 'chat', 'check', 'checkbox', 'checkmark', 'chevron-down', 'chevron-left', 'chevron-right', 'chevron-up', 'chevronDown', 'chevronLeft', 'chevronRight', 'chevronUp', 'circle-check', 'circle-status', 'circle-status-closed', 'circle-x', 'circleCheck', 'circleStatus', 'circleStatusClosed', 'circleX', 'clipboard', 'clock', 'close', 'close-small', 'close-xlarge', 'closeSmall', 'closeXlarge', 'cloud-download', 'cloud-upload', 'cloudDownload', 'cloudUpload', 'cluster', 'code-bracket', 'codeBracket', 'collapse', 'collapse-section', 'collapseSection', 'color-filter', 'colorFilter', 'colorpicker', 'column', 'comment', 'comment-add', 'comment-pencil', 'comment-plus', 'commentAdd', 'commentPencil', 'commentPlus', 'commission-county', 'commission-number', 'commissionCounty', 'commissionNumber', 'company', 'compass', 'completed', 'computer', 'computer-chip', 'computerChip', 'contacts', 'container-enlarge', 'container-reduce', 'containerEnlarge', 'containerReduce', 'control-fast-forward', 'control-next', 'control-pause', 'control-play', 'control-previous', 'control-rewind', 'control-stop', 'controlFastForward', 'controlNext', 'controlPause', 'controlPlay', 'controlPrevious', 'controlRewind', 'controlStop', 'copy', 'courthouse', 'credit-card', 'creditCard', 'crop', 'crown', 'currency', 'currency-dollar', 'currency-euro', 'currency-general', 'currency-rupes', 'currencyDollar', 'currencyEuro', 'currencyGeneral', 'currencyRupes', 'data-read', 'data-read-write', 'data-server', 'data-stack', 'dataRead', 'dataReadWrite', 'dataServer', 'dataStack', 'database', 'date', 'decline', 'desktop', 'desktop-share', 'desktopShare', 'detail-view', 'detailView', 'device-desktop', 'device-keyboard', 'device-laptop', 'device-mobile', 'device-tablet', 'deviceDesktop', 'deviceKeyboard', 'deviceLaptop', 'deviceMobile', 'deviceTablet', 'devices', 'diamond-stack', 'diamondStack', 'document', 'document-empty', 'document-gear', 'document-pencil', 'document-person', 'document-plus', 'document-stack', 'documentEmpty', 'documentGear', 'documentPencil', 'documentPerson', 'documentPlus', 'documentStack', 'documents', 'download', 'draft', 'dropdown', 'duplicate', 'edit', 'email', 'enter', 'envelope', 'envelope-open', 'envelopeOpen', 'eraser', 'expanded-list', 'expandedList', 'export', 'expression', 'external-link', 'externalLink', 'eye', 'eye-slash', 'eyeSlash', 'eyedropper', 'field', 'field-insert', 'field-merge', 'fieldInsert', 'fieldMerge', 'fields-custom', 'fields-merge', 'fields-standard', 'fieldsCustom', 'fieldsMerge', 'fieldsStandard', 'filter', 'fingerprint', 'flag', 'flash', 'flash-off', 'flash-slash', 'flashOff', 'flashSlash', 'focus-button', 'focusButton', 'folder', 'folder-open', 'folder-plus', 'folderOpen', 'folderPlus', 'follower-database', 'followerDatabase', 'formula', 'forward', 'function', 'function-folder', 'functionFolder', 'gear', 'gem', 'globe', 'globe-language', 'globeLanguage', 'grid-view', 'gridView', 'gripper-bar', 'gripper-corner', 'gripper-rectangle', 'gripper-rectangle-horizontal', 'gripperBar', 'gripperCorner', 'gripperRectangle', 'gripperRectangleHorizontal', 'hanko', 'hash', 'heading', 'health', 'heart-plus', 'heartPlus', 'help', 'hide', 'hierarchy', 'highlighter', 'history', 'home', 'id-badge', 'id-card', 'idBadge', 'idCard', 'identity-verification', 'identityVerification', 'image', 'inbox', 'indicator-current', 'indicator-incomplete', 'indicatorCurrent', 'indicatorIncomplete', 'info', 'initials', 'insert', 'italic', 'italics', 'key', 'keyboard', 'language', 'layout-card', 'layout-detail', 'layout-grid', 'layout-hybrid', 'layoutCard', 'layoutDetail', 'layoutGrid', 'layoutHybrid', 'leaf', 'line', 'line-height', 'lineHeight', 'link', 'list', 'location', 'location-pin', 'locationPin', 'lock', 'logic', 'mail', 'margin', 'megaphone', 'menu', 'menu-hamburger', 'menu-overflow-horizontal', 'menu-overflow-vertical', 'menu-triangle-down', 'menu-triangle-left', 'menu-triangle-right', 'menu-triangle-up', 'menu-waffle', 'menuHamburger', 'menuOverflowHorizontal', 'menuOverflowVertical', 'menuTriangleDown', 'menuTriangleLeft', 'menuTriangleRight', 'menuTriangleUp', 'menuWaffle', 'merge-cell', 'merge-fields-dynamic', 'mergeCell', 'mergeFieldsDynamic', 'messages', 'microphone', 'microphone-off', 'microphone-slash', 'microphoneOff', 'microphoneSlash', 'minus', 'mobile-phone', 'mobilePhone', 'move-cursor', 'moveCursor', 'movie', 'multi-arrow', 'multiArrow', 'music-note', 'musicNote', 'name', 'name-first', 'name-last', 'nameFirst', 'nameLast', 'notary', 'note', 'notification', 'number', 'number-global', 'number-list', 'numberGlobal', 'numberList', 'numbered-list', 'numberedList', 'overflow-horizontal', 'overflow-vertical', 'overflowHorizontal', 'overflowVertical', 'page-break', 'pageBreak', 'paint-brush-line', 'paint-bucket', 'paint-palette', 'paint-roller', 'paintBrushLine', 'paintBucket', 'paintPalette', 'paintRoller', 'palette', 'paperclip', 'paste', 'pause', 'payment', 'pebble-check', 'pebble-error', 'pebble-info', 'pebble-question', 'pebble-warning', 'pebbleCheck', 'pebbleError', 'pebbleInfo', 'pebbleQuestion', 'pebbleWarning', 'pencil', 'pencil-ruler', 'pencilRuler', 'people', 'people-witness', 'peopleWitness', 'percent', 'person', 'person-circle', 'person-plus', 'person-scan', 'person-sign', 'personCircle', 'personPlus', 'personScan', 'personSign', 'phone', 'phone-mobile', 'phoneMobile', 'play', 'plugin', 'plus', 'power', 'powerform', 'print', 'printer', 'process-spinner', 'processSpinner', 'push-pin', 'pushPin', 'radar', 'radio', 'read-data', 'read-write-data', 'readData', 'readWriteData', 'receipt', 'receives-copy', 'receivesCopy', 'recipient-add', 'recipient-update', 'recipientAdd', 'recipientUpdate', 'redo', 'refresh', 'reply', 'reply-all', 'replyAll', 'reports', 'rotate-left', 'rotate-right', 'rotateLeft', 'rotateRight', 'ruler', 'scan', 'seal-notary', 'sealNotary', 'search', 'select', 'select-signature-type', 'selectSignatureType', 'send', 'sent', 'settings', 'share-android', 'share-desktop', 'share-i-os', 'share-ios', 'share-web', 'shareAndroid', 'shareDesktop', 'shareIos', 'shareWeb', 'share_iOS', 'shared', 'shield', 'shield-cfr-part11', 'shield-check', 'shieldCfrPart11', 'shieldCheck', 'shopping-cart', 'shoppingCart', 'sign', 'sign-in-person', 'sign-with-witness', 'signInPerson', 'signWithWitness', 'signal', 'signature', 'smart-clause', 'smart-sections', 'smart-tag', 'smartClause', 'smartSections', 'smartTag', 'sort', 'spark', 'sparkles', 'speedometer', 'squiggle', 'stamp', 'star', 'star-filled', 'starFilled', 'state', 'status-check', 'status-end', 'status-error', 'status-info', 'status-verify', 'status-void', 'status-warn', 'statusCheck', 'statusEnd', 'statusError', 'statusInfo', 'statusVerify', 'statusVoid', 'statusWarn', 'stop', 'strikethrough', 'suggest', 'suggested', 'support', 'support-contact', 'supportContact', 'swatch', 'sync', 'table', 'table-alt', 'table-border-off', 'table-border-slash', 'table-folder', 'tableAlt', 'tableBorderOff', 'tableBorderSlash', 'tableFolder', 'tablet', 'tag', 'target', 'task-list', 'taskList', 'template-view', 'templateView', 'templates', 'text', 'text-align-center', 'text-align-end', 'text-align-left', 'text-align-right', 'text-align-start', 'text-block', 'text-center', 'text-color', 'text-indent-left', 'text-indent-right', 'text-justify', 'text-justify-center', 'text-left', 'text-long', 'text-right', 'text-short', 'textAlignCenter', 'textAlignEnd', 'textAlignLeft', 'textAlignRight', 'textAlignStart', 'textBlock', 'textCenter', 'textColor', 'textIndentLeft', 'textIndentRight', 'textJustify', 'textJustifyCenter', 'textLeft', 'textLong', 'textRight', 'textShort', 'thumbnails', 'thumbs-down', 'thumbs-down-filled', 'thumbs-up', 'thumbs-up-filled', 'thumbsDown', 'thumbsDownFilled', 'thumbsUp', 'thumbsUpFilled', 'ticket', 'title', 'transaction', 'transactions', 'trash', 'trend-negative', 'trend-positive', 'trendNegative', 'trendPositive', 'trust-center', 'trust-center-check', 'trustCenter', 'trustCenterCheck', 'type-image', 'typeImage', 'underline', 'undo', 'unlock', 'unmerge-cell', 'unmergeCell', 'upload', 'upload-cloud', 'upload-list', 'uploadCloud', 'uploadList', 'user', 'video-camera', 'video-camera-off', 'video-camera-slash', 'videoCamera', 'videoCameraOff', 'videoCameraSlash', 'view', 'voided', 'volume-high', 'volume-low', 'volume-slash', 'volumeHigh', 'volumeLow', 'volumeSlash', 'waffle', 'waiting-for-others', 'waitingForOthers', 'wallet', 'wifi', 'wifi-slash', 'wifiSlash', 'workflow', 'wrench', 'zoom-in', 'zoom-out', 'zoomIn', 'zoomOut'];
export const systemIconMap = {
  "action-required": "actionRequired",
  "add-logic": "addLogic",
  "align-bottom": "alignBottom",
  "align-center": "alignCenter",
  "align-end": "alignEnd",
  "alignRight": "alignEnd",
  "align-right": "alignEnd",
  "align-mid": "alignMid",
  "align-start": "alignStart",
  "alignLeft": "alignStart",
  "align-left": "alignStart",
  "align-top": "alignTop",
  "arrow-down": "arrowDown",
  "arrow-left": "arrowLeft",
  "arrow-right": "arrowRight",
  "arrow-up": "arrowUp",
  "arrow-up-left": "arrowUpLeft",
  "arrow-up-right": "arrowUpRight",
  "arrows-in": "arrowsIn",
  "arrows-out": "arrowsOut",
  "audio-wave": "audioWave",
  "auto-fill": "autoFill",
  "sealNotary": "award",
  "seal-notary": "award",
  "notification": "bell",
  "bell-slash": "bellSlash",
  "book-open": "bookOpen",
  "book-person": "bookPerson",
  "box-plus-above": "boxPlusAbove",
  "addRowAbove": "boxPlusAbove",
  "add-row-above": "boxPlusAbove",
  "box-plus-after": "boxPlusAfter",
  "addColumnRight": "boxPlusAfter",
  "add-column-right": "boxPlusAfter",
  "box-plus-before": "boxPlusBefore",
  "addColumnLeft": "boxPlusBefore",
  "add-column-left": "boxPlusBefore",
  "box-plus-below": "boxPlusBelow",
  "addRowBelow": "boxPlusBelow",
  "add-row-below": "boxPlusBelow",
  "browserStack": "browser",
  "browser-stack": "browser",
  "building-civic": "buildingCivic",
  "courthouse": "buildingCivic",
  "commissionCounty": "buildingCivic",
  "commission-county": "buildingCivic",
  "building-company": "buildingCompany",
  "company": "buildingCompany",
  "building-generic": "buildingGeneric",
  "building-person": "buildingPerson",
  "bulk-send": "bulkSend",
  "bulleted-list": "bulletedList",
  "list": "bulletedList",
  "date": "calendar",
  "carbon-copy": "carbonCopy",
  "caret-large-down": "caretLargeDown",
  "caret-large-left": "caretLargeLeft",
  "caret-large-right": "caretLargeRight",
  "caret-large-up": "caretLargeUp",
  "caret-xlarge-down": "caretXlargeDown",
  "caret-xlarge-left": "caretXlargeLeft",
  "caret-xlarge-right": "caretXlargeRight",
  "caret-xlarge-up": "caretXlargeUp",
  "chart-bar": "chartBar",
  "reports": "chartBar",
  "chart-pie": "chartPie",
  "completed": "check",
  "chevron-down": "chevronDown",
  "caretDown": "chevronDown",
  "caret-down": "chevronDown",
  "chevron-left": "chevronLeft",
  "caretLeft": "chevronLeft",
  "caret-left": "chevronLeft",
  "chevron-right": "chevronRight",
  "caretRight": "chevronRight",
  "caret-right": "chevronRight",
  "chevron-up": "chevronUp",
  "caretUp": "chevronUp",
  "caret-up": "chevronUp",
  "circle-status": "circleStatus",
  "circle-status-closed": "circleStatusClosed",
  "circle-x": "circleX",
  "paste": "clipboard",
  "waitingForOthers": "clock",
  "waiting-for-others": "clock",
  "close-small": "closeSmall",
  "close-xlarge": "closeXlarge",
  "cloud-download": "cloudDownload",
  "cloud-upload": "cloudUpload",
  "uploadCloud": "cloudUpload",
  "upload-cloud": "cloudUpload",
  "code-bracket": "codeBracket",
  "collapse-section": "collapseSection",
  "color-filter": "colorFilter",
  "comment-pencil": "commentPencil",
  "suggest": "commentPencil",
  "comment-plus": "commentPlus",
  "commentAdd": "commentPlus",
  "comment-add": "commentPlus",
  "computer-chip": "computerChip",
  "container-enlarge": "containerEnlarge",
  "container-reduce": "containerReduce",
  "control-fast-forward": "controlFastForward",
  "control-next": "controlNext",
  "control-pause": "controlPause",
  "pause": "controlPause",
  "control-play": "controlPlay",
  "play": "controlPlay",
  "control-previous": "controlPrevious",
  "control-rewind": "controlRewind",
  "control-stop": "controlStop",
  "stop": "controlStop",
  "credit-card": "creditCard",
  "currency-dollar": "currencyDollar",
  "currency-euro": "currencyEuro",
  "currency-general": "currencyGeneral",
  "currency-rupes": "currencyRupes",
  "data-read": "dataRead",
  "readData": "dataRead",
  "read-data": "dataRead",
  "data-read-write": "dataReadWrite",
  "readWriteData": "dataReadWrite",
  "read-write-data": "dataReadWrite",
  "data-server": "dataServer",
  "data-stack": "dataStack",
  "device-desktop": "deviceDesktop",
  "desktop": "deviceDesktop",
  "computer": "deviceDesktop",
  "device-keyboard": "deviceKeyboard",
  "device-laptop": "deviceLaptop",
  "device-mobile": "deviceMobile",
  "mobilePhone": "deviceMobile",
  "mobile-phone": "deviceMobile",
  "phoneMobile": "deviceMobile",
  "phone-mobile": "deviceMobile",
  "device-tablet": "deviceTablet",
  "tablet": "deviceTablet",
  "diamond-stack": "diamondStack",
  "documents": "document",
  "document-empty": "documentEmpty",
  "document-gear": "documentGear",
  "document-pencil": "documentPencil",
  "document-person": "documentPerson",
  "document-plus": "documentPlus",
  "document-stack": "documentStack",
  "copy": "duplicate",
  "email": "envelope",
  "mail": "envelope",
  "envelope-open": "envelopeOpen",
  "external-link": "externalLink",
  "view": "eye",
  "eye-slash": "eyeSlash",
  "hide": "eyeSlash",
  "colorpicker": "eyedropper",
  "fieldsStandard": "field",
  "fields-standard": "field",
  "field-insert": "fieldInsert",
  "field-merge": "fieldMerge",
  "fieldsMerge": "fieldMerge",
  "fields-merge": "fieldMerge",
  "fields-custom": "fieldsCustom",
  "state": "flag",
  "flash-slash": "flashSlash",
  "flashOff": "flashSlash",
  "flash-off": "flashSlash",
  "focus-button": "focusButton",
  "folder-open": "folderOpen",
  "folder-plus": "folderPlus",
  "follower-database": "followerDatabase",
  "function": "formula",
  "function-folder": "functionFolder",
  "settings": "gear",
  "globe-language": "globeLanguage",
  "globe": "globeLanguage",
  "language": "globeLanguage",
  "gripper-bar": "gripperBar",
  "gripperRectangle": "gripperBar",
  "gripper-rectangle": "gripperBar",
  "gripper-corner": "gripperCorner",
  "gripper-rectangle-horizontal": "gripperRectangleHorizontal",
  "heart-plus": "heartPlus",
  "pebbleQuestion": "help",
  "pebble-question": "help",
  "id-badge": "idBadge",
  "id-card": "idCard",
  "identity-verification": "identityVerification",
  "typeImage": "image",
  "type-image": "image",
  "indicator-current": "indicatorCurrent",
  "indicator-incomplete": "indicatorIncomplete",
  "enter": "insert",
  "italic": "italics",
  "layout-card": "layoutCard",
  "templateView": "layoutCard",
  "template-view": "layoutCard",
  "layout-detail": "layoutDetail",
  "detailView": "layoutDetail",
  "detail-view": "layoutDetail",
  "expandedList": "layoutDetail",
  "expanded-list": "layoutDetail",
  "layout-grid": "layoutGrid",
  "gridView": "layoutGrid",
  "grid-view": "layoutGrid",
  "layout-hybrid": "layoutHybrid",
  "line-height": "lineHeight",
  "location-pin": "locationPin",
  "location": "locationPin",
  "menuHamburger": "menu",
  "menu-hamburger": "menu",
  "menu-triangle-down": "menuTriangleDown",
  "menu-triangle-left": "menuTriangleLeft",
  "menu-triangle-right": "menuTriangleRight",
  "menu-triangle-up": "menuTriangleUp",
  "merge-cell": "mergeCell",
  "merge-fields-dynamic": "mergeFieldsDynamic",
  "chat": "messages",
  "microphone-slash": "microphoneSlash",
  "microphoneOff": "microphoneSlash",
  "microphone-off": "microphoneSlash",
  "multi-arrow": "multiArrow",
  "moveCursor": "multiArrow",
  "move-cursor": "multiArrow",
  "music-note": "musicNote",
  "name-first": "nameFirst",
  "name-last": "nameLast",
  "commissionNumber": "number",
  "commission-number": "number",
  "hash": "number",
  "number-global": "numberGlobal",
  "numbered-list": "numberedList",
  "numberList": "numberedList",
  "number-list": "numberedList",
  "overflow-horizontal": "overflowHorizontal",
  "menuOverflowHorizontal": "overflowHorizontal",
  "menu-overflow-horizontal": "overflowHorizontal",
  "overflow-vertical": "overflowVertical",
  "menuOverflowVertical": "overflowVertical",
  "menu-overflow-vertical": "overflowVertical",
  "page-break": "pageBreak",
  "paint-brush-line": "paintBrushLine",
  "paint-bucket": "paintBucket",
  "paint-palette": "paintPalette",
  "palette": "paintPalette",
  "paint-roller": "paintRoller",
  "attachment": "paperclip",
  "edit": "pencil",
  "pencil-ruler": "pencilRuler",
  "shared": "people",
  "people-witness": "peopleWitness",
  "name": "person",
  "user": "person",
  "person-circle": "personCircle",
  "person-plus": "personPlus",
  "recipientAdd": "personPlus",
  "recipient-add": "personPlus",
  "person-scan": "personScan",
  "person-sign": "personSign",
  "add": "plus",
  "print": "printer",
  "process-spinner": "processSpinner",
  "push-pin": "pushPin",
  "receives-copy": "receivesCopy",
  "recipient-update": "recipientUpdate",
  "sync": "refresh",
  "reply-all": "replyAll",
  "rotate-left": "rotateLeft",
  "rotate-right": "rotateRight",
  "dropdown": "select",
  "select-signature-type": "selectSignatureType",
  "sent": "send",
  "share-android": "shareAndroid",
  "share-desktop": "shareDesktop",
  "desktopShare": "shareDesktop",
  "desktop-share": "shareDesktop",
  "share-ios": "shareIos",
  "share_iOS": "shareIos",
  "share-i-os": "shareIos",
  "share-web": "shareWeb",
  "trustCenter": "shield",
  "trust-center": "shield",
  "shield-cfr-part11": "shieldCfrPart11",
  "shield-check": "shieldCheck",
  "trustCenterCheck": "shieldCheck",
  "trust-center-check": "shieldCheck",
  "shopping-cart": "shoppingCart",
  "signature": "sign",
  "sign-in-person": "signInPerson",
  "sign-with-witness": "signWithWitness",
  "radar": "signal",
  "smart-clause": "smartClause",
  "smart-sections": "smartSections",
  "smart-tag": "smartTag",
  "sparkles": "spark",
  "star-filled": "starFilled",
  "status-check": "statusCheck",
  "pebbleCheck": "statusCheck",
  "pebble-check": "statusCheck",
  "circleCheck": "statusCheck",
  "circle-check": "statusCheck",
  "status-end": "statusEnd",
  "status-error": "statusError",
  "pebbleError": "statusError",
  "pebble-error": "statusError",
  "status-info": "statusInfo",
  "pebbleInfo": "statusInfo",
  "pebble-info": "statusInfo",
  "info": "statusInfo",
  "status-verify": "statusVerify",
  "status-void": "statusVoid",
  "block": "statusVoid",
  "voided": "statusVoid",
  "status-warn": "statusWarn",
  "pebbleWarning": "statusWarn",
  "pebble-warning": "statusWarn",
  "alert": "statusWarn",
  "alertTriangle": "statusWarn",
  "alert-triangle": "statusWarn",
  "supportContact": "support",
  "support-contact": "support",
  "table-alt": "tableAlt",
  "table-border-slash": "tableBorderSlash",
  "tableBorderOff": "tableBorderSlash",
  "table-border-off": "tableBorderSlash",
  "table-folder": "tableFolder",
  "task-list": "taskList",
  "text-align-center": "textAlignCenter",
  "textCenter": "textAlignCenter",
  "text-center": "textAlignCenter",
  "text-align-end": "textAlignEnd",
  "textAlignRight": "textAlignEnd",
  "text-align-right": "textAlignEnd",
  "textRight": "textAlignEnd",
  "text-right": "textAlignEnd",
  "text-align-start": "textAlignStart",
  "textAlignLeft": "textAlignStart",
  "text-align-left": "textAlignStart",
  "textLeft": "textAlignStart",
  "text-left": "textAlignStart",
  "text-block": "textBlock",
  "text-color": "textColor",
  "text-indent-left": "textIndentLeft",
  "text-indent-right": "textIndentRight",
  "text-justify-center": "textJustifyCenter",
  "textJustify": "textJustifyCenter",
  "text-justify": "textJustifyCenter",
  "text-long": "textLong",
  "text-short": "textShort",
  "thumbs-down": "thumbsDown",
  "thumbs-down-filled": "thumbsDownFilled",
  "thumbs-up": "thumbsUp",
  "thumbs-up-filled": "thumbsUpFilled",
  "transactions": "transaction",
  "trend-negative": "trendNegative",
  "trend-positive": "trendPositive",
  "unmerge-cell": "unmergeCell",
  "upload-list": "uploadList",
  "video-camera": "videoCamera",
  "video-camera-slash": "videoCameraSlash",
  "videoCameraOff": "videoCameraSlash",
  "video-camera-off": "videoCameraSlash",
  "volume-high": "volumeHigh",
  "volume-low": "volumeLow",
  "volume-slash": "volumeSlash",
  "menuWaffle": "waffle",
  "menu-waffle": "waffle",
  "payment": "wallet",
  "wifi-slash": "wifiSlash",
  "zoom-in": "zoomIn",
  "zoom-out": "zoomOut"
};